// extracted by mini-css-extract-plugin
export default {"tinyBanner":"TinyBanner_tinyBanner__w+wII"};